import React from 'react';
import KickImage from 'Reuseables/KickImage';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Container
} from 'reactstrap';
import { convertToRupiah } from '../../utils';
import moment from 'moment';
import { ASSET_IMAGE } from '../../config';
import { Link } from 'react-router-dom';
import ModalSnapPay from './ModalSnapPay';

import CloseIcon from '../../images/close-button-search.png';

const PaymentConfirmLink = ({id, invoiceNumber, url, paymentMethod, onRedirectXendit, history, total_amount}) => (
  id?
  (
    paymentMethod === 'virtual_account'?
      <Button className="btn-green" onClick={()=>onRedirectXendit(url)}>Payment Confirmation</Button>
    :
      <Button className="btn-green" onClick={() => paymentConfirmationBank(history, total_amount, invoiceNumber)}>Payment Confirmation</Button>
  )
  : null
)

const paymentConfirmationBank = (history, total_amount, invoiceNumber) => {
  const pathname = `/payment_confirmation/${invoiceNumber}`;

  history.push({pathname, search: `?transfer_amount=${parseInt(total_amount)}`})
}

const BankAccountContainer = ({ accountNumber, accountName, bankName }) => (
  <div className="bank-content">
    <div className="bank-icon">
      <KickImage className="img-responsive" src={`${ASSET_IMAGE}/email/${bankName.toLowerCase()}.png`} alt={bankName} />
    </div>
    <div className="text-desc2 third-modal">
      <p>{accountNumber}</p>
      <p>{accountName}</p>
    </div>
  </div>
)

class ModalWalletLog extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      _modalSnapIsOpen: false
    }
  }
  componentDidUpdate(prevProps){
    if(!prevProps.isOpen && this.props.isOpen){
      this.setState({
        _modalSnapIsOpen: false
      })
    }
  }

  _handleOnToggleModalSnap = async () => {
    await this.setState({ _modalSnapIsOpen: !this.state._modalSnapIsOpen })
    const { _modalSnapIsOpen } = this.state;
    if(!_modalSnapIsOpen && this.props.onToggle) this.props.onToggle();
  }

  render(){
    const totalReceived = this.props.type == 'BALANCE_OUT' && (Number(this.props.total_amount) - Number(this.props.fee))

    return(
      <div>
        <ModalSnapPay
          isCloseable
          isOpen={this.state._modalSnapIsOpen}
          invoiceNumber={this.props.invoiceNumber}
          headerTitle={this.props.invoiceNumber}
          redirectUrl={this.props.invoiceUrl}
          onToggle={this._handleOnToggleModalSnap}
        />
        <Modal
          className="kick-modal payment-pending"
          isOpen={this.props.isOpen}
          toggle={this.props.onToggle}
        >
        <div onClick={this.props.onToggle} style={{textAlign: 'right', padding: '15px'}}>
          <KickImage src={CloseIcon} style={{width: '15px'}} className={'hover-pointer'}/>
        </div>
        {
          this.props.isOpen?
          <Container id="payment">
            <ModalHeader id="header-payment-pending">
              INVOICE NUMBER: <span id="invoice-number">{this.props.disbursement_number ? this.props.disbursement_number : this.props.invoiceNumber}</span>
            </ModalHeader>
            {
              this.props.type == 'BALANCE_OUT' ?
              <ModalBody>
              <div>
                <p className="display_bold">Tanggal Transaksi</p>
                <p>{moment(this.props.created_at).format("DD MMMM YYYY")}</p>
              </div>
              <div>
                <p className="display_bold">Nominal Cash Out</p>
                <p>IDR {convertToRupiah(parseInt(this.props.total_amount, 10))}</p>
              </div>
              <div>
                <p className="display_bold">Cash Out Fee</p>
                <p>IDR {convertToRupiah(parseInt(this.props.fee, 10))}</p>
              </div>
              <div>
                <p className="display_bold">Total Amount Received</p>
                <p>IDR {convertToRupiah(parseInt(totalReceived, 10))}</p>
              </div>
              <div>
                <p className="display_bold">Tipe Transaksi</p>
                <p>{this.props.type.replace(/[_]/g,' ').toUpperCase()}</p>
              </div>
              <div>
                <p className="display_bold">No. Rekening Penerima</p>
                <p>{this.props.dataBank && this.props.dataBank.account_number_recipient? this.props.dataBank.account_number_recipient : "-"}</p>
              </div>
              <div>
                <p className="display_bold">Nama Penerima</p>
                <p>{this.props.dataBank && this.props.dataBank.account_name_recipient? this.props.dataBank.account_name_recipient : "-"} </p>
              </div>
              <div>
                <p className="display_bold">Nama Bank Penerima</p>
                <p>{this.props.dataBank && this.props.dataBank.bank_name_recipient? this.props.dataBank.bank_name_recipient : "-"} </p>
              </div>
              <div>
                <p className="display_bold">Catatan</p>
                <p>{!this.props.note ? '__' : this.props.note}</p>
              </div>
            </ModalBody>
            :
            <ModalBody>
              <div>
                <p className="display_bold">Tanggal Transaksi</p>
                <p>{moment(this.props.created_at).format("DD MMMM YYYY")}</p>
              </div>
              <div>
                <p className="display_bold">Jumlah</p>
                <p>IDR {convertToRupiah(parseInt(this.props.total_amount, 10))}</p>
              </div>
              {
                this.props.type ?
                <div>
                  <p className="display_bold">Tipe Transaksi</p>
                  <p>{this.props.type.replace(/[_]/g,' ').toUpperCase()}</p>
              </div>
              : null
              }
              {
                this.props.paymentMethod ? <div>
                <p className="display_bold">Metode Pembayaran</p>
                <p>{this.props.paymentMethod.replace(/[_]/g,' ').toUpperCase()}</p>
              </div> : null
              }
              {/* {
                this.props.paymentMethod == 'bank_transfer' || this.props.paymentMethod == 'virtual_account' ?
                <div>
                  <p className="display_bold">Instruksi</p>
                  <p>Harap melakukan pembayaran ke: </p>
                {
                  this.props.bankAccount.map(bank =>
                    <BankAccountContainer
                    key={bank.id}
                    accountNumber={bank.account_number}
                    accountName={bank.account_name}
                    bankName={bank.bank_name}
                    />
                  )
                }
              </div> : null
              } */}
              {/* <p>payment</p> */}
              {
                this.props.expiredPayment && this.props.type==="TOPUP"? null
                :
                (
                  this.props.type === "TOPUP" ?
                    <div className="wrap-button-text">
                      {
                        this.props.paymentVia === 'vt'?
                        <Button className="btn-green" onClick={()=>this.setState({_modalSnapIsOpen: true})}>
                          Payment Confirmation
                        </Button>
                        :
                        <PaymentConfirmLink
                          id={this.props.id}
                          invoiceNumber={this.props.invoiceNumber}
                          total_amount={this.props.total_amount}
                          url={this.props.invoiceUrl}
                          paymentMethod={this.props.paymentMethod}
                          onRedirectXendit={url => window.location = url}
                          history={this.props.history}
                        />
                      }
                    </div>
                  : null
                )
              }
            </ModalBody>
            }
          </Container>
          :null
        }
        </Modal>
      </div>
    )
  }
}

// const ModalWalletLog = props => {
//   return(

//   )
// }
export default ModalWalletLog;
